import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchEmployeeLoanList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/employeeLoan/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
                dispatch('fetchEmployeeLoanList', payload)
            } else {
                commit('setEmployeeLoanList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})         
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const emailLoanList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    setTimeout(() => {
        commit('displayMessageAlert', {message: 'Admin will receive an email in a few minutes.', type: 'Info'})
        commit('toggleLoadingState', false)
    }, 1000);
    axios.post('/employeeLoan/emailLoanList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchEmployeeLoanData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/employeeLoan/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {

            commit('setEmployeeLoanData', {response: res.data.response})   
            dispatch('loadEmployeeLoanBalance', {staff_id: res.data.response.staff_id})
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetEmployeeLoanData')
        }
        dispatch('fetchTaxSetting')

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitEmployeeLoanData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/employeeLoan/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
           
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteEmployeeLoanData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/employeeLoan/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchEmployeeLoanList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const loadEmployeeLoanBalance = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/employeeLoan/loadEmployeeLoanBalance.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setEmployeeLoanBalance', res.data.total_balance)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/employeeLoan/actions.js